import { ePlatforms } from '@common/networks';
import { IParseService } from './base-parse';
import { EVMParserService } from './transaction-parser.service';

export abstract class ParseFactory
{
    public static CreateParse(platform: ePlatforms, injector): IParseService
    {
        switch (platform)
        {
            case ePlatforms.EVM:
                return new EVMParserService(injector);
        }
    }

}